import { combineReducers, applyMiddleware, createStore, compose } from 'redux';
import storage from 'redux-persist/lib/storage';
import { persistStore, persistReducer } from 'redux-persist';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import * as reducers from 'Store/modules/reducers';
import { sagaMiddleware } from 'Store/middlewares';
import { RESET_STORE_TYPE } from 'Store/modules/auth/types';

export const history = createBrowserHistory();

const persistConfig = {
  version: 1,
  key: 'root',
  storage,
  whitelist: ['auth', 'user'],
  timeout: null,
};

const appReducer = value =>
  combineReducers({
    ...reducers,
    router: connectRouter(value),
  });

const rootReducer = (state, action) => {
  const newState = action.type === RESET_STORE_TYPE ? undefined : state;
  return appReducer(history)(newState, action);
};

const persistedReducer = persistReducer(persistConfig, rootReducer);
const routerMiddlewareInstance = routerMiddleware(history);
const middlewares = [sagaMiddleware, routerMiddlewareInstance];
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const store = createStore(
  persistedReducer,
  composeEnhancers(applyMiddleware(...middlewares))
);
export const persistor = persistStore(store);
